import { Component } from "react";

export default class ErrorBoundary extends Component {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error("Unhandled UI error:", error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center gap-6 px-6 text-center">
                    <p className="font-display text-3xl">Something went wrong.</p>
                    <p className="text-sm text-[#A1A1AA] max-w-md">
                        Please reload the page. If the problem continues, try again in a few minutes.
                    </p>
                    <button onClick={() => window.location.reload()} className="btn-gold">
                        Reload
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}
